import React from 'react';
import { classes } from '../../../lib';
import Styles from './PrivacyItem.module.less';

export type PrivacyItemProps = {
    icon: React.ReactNode;
    text: string;
    link: React.ReactNode;
};

export const PrivacyItem = ({
    link,
    icon,
    text,
}: PrivacyItemProps): JSX.Element => {
    return (
        <div className={classes('vertical left-top g16 shrink', Styles.item)}>
            <div className={classes('large-alude', Styles.icon)}>{icon}</div>
            <div className="large-alude">{text}</div>
            <div>{link}</div>
        </div>
    );
};
